// Typographie française, passe GLOBALE du thème : espace insécable avant ; : ! ? »
// et après «, et dans les milliers (1 000). Évite la ponctuation orpheline en
// début de ligne sur mobile. Parcourt le contenu visible de toute la page, hors
// prix / formulaires / scripts. Idempotent (relançable sans effet indésirable).
function lbTypoPassTheme() {
  var NB = String.fromCharCode(160);
  var motif = / [;:!?»]|« |\d \d{3}(?!\d)/;
  var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      var v = node.nodeValue;
      if (!v || !motif.test(v) || v.indexOf("€") !== -1) return NodeFilter.FILTER_REJECT;
      var p = node.parentElement;
      if (!p || p.closest("script,style,textarea,input,select,option,button,.price,.money,.jdgm-carousel,[data-lb-tx-tailles],[data-lb-tx-pointures]")) {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  var nodes = [], n;
  while ((n = walker.nextNode())) nodes.push(n);
  nodes.forEach(function (node) {
    node.nodeValue = node.nodeValue
      .replace(/ ([;:!?»])/g, NB + "$1")
      .replace(/« /g, "«" + NB)
      .replace(/(\b\d{1,3}) (\d{3}\b)/g, "$1" + NB + "$2");
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", lbTypoPassTheme);
} else {
  lbTypoPassTheme();
}
